if (!customElements.get("nss-accordion")) {
    customElements.define("nss-accordion", class NSSAccordion extends HTMLElement {
        constructor() {
            super();
            this.selectors = {
                toggle: ".js-nss-accordion-toggle",
                content: ".js-nss-accordion-panel"
            };
            this.dataLevel = this.getAttribute("data-level");
            this.dataClose = this.getAttribute("data-close")!="false"
            this.toggles = this.querySelectorAll(`${this.selectors.toggle}[data-level="${this.dataLevel}"]`);
            this.contents = this.querySelectorAll(`${this.selectors.content}[data-level="${this.dataLevel}"]`);
            this.init();
        }

        init() {
            this.toggles.forEach(el => {
                el.addEventListener('click', () => {

                    this.handleToggleClick(el);
                });
            });
        }

        handleToggleClick(toggle) {
            const isExpanded = toggle.getAttribute('aria-expanded') === 'true';
            const contentId = toggle.getAttribute('aria-controls');
            const content = this.querySelector(`#${contentId}`);

            // Collapse all toggles and panels
            this.resetAccordion();

            // Expand the clicked toggle and its corresponding content if it was not already expanded
            if (!isExpanded) {
                toggle.setAttribute('aria-expanded', 'true');
                content.classList.add('is-open');
            }else{
                toggle.setAttribute('aria-expanded', 'false');
                content.classList.remove('is-open');
            }
        }

        resetAccordion() {
            // Collapse all toggles and panels
            if ( this.dataClose) {
                this.toggles.forEach(toggle =>
                    toggle.setAttribute('aria-expanded', 'false')
                );
                this.contents.forEach(content =>
                    content.classList.remove('is-open')
                );
            }
        }
    });
}